export default __webpack_public_path__ + "sign-out-option.png";